// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B53T","left":"styles_left__1CvES"};